import {ReactNode, useState} from 'react';
import CssBaseline from '@mui/material/CssBaseline';
import {
  Root,
  Header,
  EdgeSidebar,
  EdgeTrigger,
  // InsetContainer,
  // InsetSidebar,
  // InsetAvoidingView,
  SidebarContent,
  Footer,
  Content,
  Scheme,
} from '@mui-treasury/layout';
import {Box, IconButton, useTheme} from '@mui/material';
import NavigatorToggle from './NavigatorToggle';
import Clear from '@mui/icons-material/Clear';

type PageLayoutProps = {
  header: JSX.Element;
  footer: JSX.Element;
  sidebar?: {
    navigatorContent?: JSX.Element | undefined;
    legendContent?: JSX.Element | undefined;
  };
  children?: ReactNode;
  globalBannerCallback?: () => Promise<void>;
  storybook?: boolean;
};

// Implementation of the layout scheme using the mui-treasury library
// https://mui-treasury.com/layout/core-concept/
const layoutScheme: Scheme = {
  header: {
    config: {
      xs: {
        position: 'sticky',
        height: 'auto',
      },
      md: {
        position: 'relative',
        height: 'auto',
      },
    },
  },
  rightEdgeSidebar: {
    config: {
      xs: {
        variant: 'temporary',
        width: 'auto',
      },
    },
  },
};

const PageLayout = ({header, footer, sidebar = undefined, children}: PageLayoutProps) => {
  const theme = useTheme();
  const [content, setContent] = useState('navigator');

  return (
    <>
      <Root scheme={layoutScheme}>
        <CssBaseline />
        <Header>
          <Box
            sx={{
              flex: 1,
              display: 'flex',
              flexDirection: 'row',
              alignItems: 'center',
              justifyContent: 'space-between',
            }}
          >
            {header}
            <EdgeTrigger target={{anchor: 'right', field: 'open'}}>
              {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
              {/* @ts-ignore */}
              {(open, setOpen) => (
                <NavigatorToggle
                  // aiGuideVisible={false}
                  navigatorVisible={sidebar?.navigatorContent != undefined}
                  legendVisible={sidebar?.legendContent != undefined}
                  trigger={(source) => {
                    setOpen(!open);
                    setContent(source);
                  }}
                />
              )}
            </EdgeTrigger>
          </Box>
        </Header>
        {sidebar && (
          <EdgeSidebar anchor='right'>
            <Box
              sx={{
                flex: 1,
                display: 'flex',
                alignItems: 'flex-start',
                px: 2,
                py: 2,
                width: '430px',
                background: theme.palette.grey[200],
              }}
            >
              <SidebarContent>
                <EdgeTrigger target={{anchor: 'right', field: 'open'}}>
                  {/* eslint-disable-next-line @typescript-eslint/ban-ts-comment */}
                  {/* @ts-ignore */}
                  {(collapsed, setCollapsed) => (
                    <Box width='100%' display='flex' justifyContent='flex-end'>
                      <IconButton
                        onClick={() => {
                          setCollapsed(!collapsed);
                        }}
                      >
                        <Clear />
                      </IconButton>
                    </Box>
                  )}
                </EdgeTrigger>
                {content == 'navigator' && sidebar.navigatorContent}
                {content == 'legend' && sidebar.legendContent}
              </SidebarContent>
            </Box>
          </EdgeSidebar>
        )}
        <Content>{children}</Content>
        <Footer>
          <Box>{footer}</Box>
        </Footer>
      </Root>
    </>
  );
};

export default PageLayout;
